import type { BulkMessage, CreateMessageInput } from '@grosync/common';
import { apiGet, apiPost } from './client';

/** 메시지 발송 이력 (최신순). */
export function fetchMessages(): Promise<BulkMessage[]> {
  return apiGet<BulkMessage[]>('/api/messages');
}

/** 단체 메시지 발송(또는 예약). 서버가 수신자 수·건수·비용을 계산해 반환. */
export function createMessage(body: CreateMessageInput): Promise<BulkMessage> {
  return apiPost<BulkMessage>('/api/messages', body);
}
